import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import shape1 from "../../../Assets/Images/Shape 1.png";
import shape2 from "../../../Assets/Images/Shape 2.png";
import shape3 from "../../../Assets/Images/shapeFive.png";
import shape4 from "../../../Assets/Images/Shape six.png";
import shape5 from "../../../Assets/Images/ShapeSeven.png";
import wrapperIcon from "../../../Assets/Images/Icon Wrapper.png";
import "../AskedQuestion/NewAskedQuestion.css";
import "../Technology/AllBanner/DatabaseBanner.css";
import { Link } from "react-router-dom";
const industries = [
  {
    id: 1,
    title: "Professional Services",
    desc: "We assist teams in staying responsive on the go, without long email threads, we keep client updates, approvals, and schedules accessible.",
    icon: "https://i.ibb.co.com/p6QSD6ky/icon-1.png",
  },
  {
    id: 2,
    title: "Telecommunications",
    desc: "We develop apps that allow users to control services, receive updates and get support without confusing them or asking them to do more than is necessary.",
    icon: "https://i.ibb.co.com/d4Mc6Xhb/icon-2.png",
  },
  {
    id: 3,
    title: "Social Media",
    desc: "We help platforms to remain usable as they scale, for example keeping apps fast, stable and manageable even when user behaviour is unpredictable.",
    icon: "https://i.ibb.co.com/67DWf8tv/icon-3.png",
  },
  {
    id: 4,
    title: "Payments",
    desc: "We develop payment apps where user transactions feel fast and safe, because hesitation or delays very quickly destroy user trust.",
    icon: "https://i.ibb.co.com/8DcX3SDZ/icon-4.png",
  },
  {
    id: 5,
    title: "Hotel Management",
    desc: "We assist hotel teams to handle the bookings, rooms, staff tasking, and guest communication on a busy day with limited time.",
    icon: "https://i.ibb.co.com/wht5GbQ2/icon-5.png",
  },
  {
    id: 6,
    title: "E-Commerce",
    desc: "We create shopping apps that are fast to load, easy to buy from and encourage customers to return for more!",
    icon: "https://i.ibb.co.com/ZRSWDNgg/icon-6.png",
  },
  {
    id: 7,
    title: "Insurance",
    desc: "We help insurers to make claims and access policies less stressful by designing apps that are clear and easy to navigate through.",
    icon: "https://i.ibb.co.com/gbzz8rXM/icon-7.png",
  },
  {
    id: 8,
    title: "Healthcare",
    desc: "We create applications that are privacy respectful and can assist patients and staff with schedule, information and communication management in a seamless way.",
    icon: "https://i.ibb.co.com/Kxqc9zDk/icon-8.png",
  },
  {
    id: 9,
    title: "Food Delivery",
    desc: "We assist delivery platforms in coordinating delivery between orders, riders and customers with real-time updates that minimize confusion.",
    icon: "https://i.ibb.co.com/MkTZ9PGm/icon-9.png",
  },
  {
    id: 10,
    title: "Education",
    desc: "We create learning apps that supplement lessons and assignments and communication away from the traditional classroom.",
    icon: "https://i.ibb.co.com/p63PmFJ4/icon-10.png",
  },
  {
    id: 11,
    title: "POS System",
    desc: "We get the teams in retail to process sales, check inventory, and look at reports without having to slow down the floor.",
    icon: "https://i.ibb.co.com/B5GYR1jw/icon-11.png",
  },
  {
    id: 12,
    title: "Banking",
    desc: "We develop banking applications that facilitate daily banking transactions and ensure the security of the users at every step.",
    icon: "https://i.ibb.co.com/Nz6FgLH/icon-12.png",
  },
];

const ServicesIndustries = () => {
  const [hovered, setHovered] = useState(null);
  // variants: parent controls card transform, child controls sliding-up animation
  const parentVariants = {
    rest: { scale: 1, boxShadow: "0 1px 4px rgba(100, 95, 95, 0.05)", y: 0 },
    hover: {
      scale: 1.02,
      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
      y: -8,
      transition: { type: "tween", duration: 0.5, ease: "easeOut" },
    },
  };

  const childVariants = {
    rest: {},
    hover: { transition: { staggerChildren: 0.04 } },
  };

  const childItemVariants = {
    rest: { y: 0, opacity: 1 },
    hover: {
      y: -8,
      opacity: 1,
      transition: { duration: 0.18, ease: "easeOut" },
    },
  };
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const visibleIndustries =
    isMobile && !showAll ? industries.slice(0, 7) : industries;
  return (
    <div>
      <section
        className="px-5 border-bottom  bg-light"
        style={{
          position: "relative",
          overflow: "visible",
          borderBottom: "1px solid #e6eef0",
          zIndex: "4",
        }}
      >
        {/* decorative gradient - top-right, very low opacity */}
        <img
          className="d-none d-md-flex"
          src={shape1}
          alt="shape 1"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            width: "460px",

            zIndex: 0,
            pointerEvents: "none",
          }}
        />
        <img
          className="d-flex d-md-none"
          src={shape3}
          alt="shape 3"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            minWidth: "50%",
            minHeight: "10%",

            zIndex: 0,
          }}
        />
        <img
          className="d-flex d-md-none"
          src={shape4}
          alt="shape 3"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 800,

            minWidth: "50%",
            minHeight: "10%",

            zIndex: 0,
          }}
        />

        {/* left decorative shape (shape2) aligned to the section start and vertically centered */}
        {/* <img className="d-md-none"
          src={shape4}
          alt="shape 2 left"
          style={{
            position: 'absolute',
            left: -8,
            top: '50%',
            transform: 'translateY(-50%)',
            width: isMobile ? 500 : 320,
            maxWidth: isMobile ? '60%' : '52%',
            opacity: isMobile ? 0.14 : 0.06,
            zIndex: 0,
            pointerEvents: 'none',
          }}
        /> */}

        <div
          id="industry"
          className="container ind-padding px-40 text-center pb-5"
          style={{ position: "relative", zIndex: 1 }}
        >
          <h2 className="fw-semibold  pt-5 Tech-heading text-black mb-2">
            Industries Where Our Mobile Apps Make Work Easier
          </h2>
          <p className="text-muted database-text mb-4">
            We do not build the same app for every industry. We learn how work actually happens, then design mobile apps that reduce friction where it hurts most.
          </p>
          <Link to="/contact-us/build-business">
            <motion.button
              type="button"
              className="data-button px-5 py-3 rounded-pill mb-5"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 30px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{ backgroundColor: "#12869E", boxShadow: "none" }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              style={{ border: "none", color: "#fff", fontSize: "2rem" }}
            >
              Start Your Project
            </motion.button>
          </Link>

          <div className="row gy-5 w-100 w-md-75 gx-6 w-75 mx-auto ">
            {visibleIndustries.map((industry) => (
              <div key={industry.id} className="col-12  col-md-6 col-lg-4">
                <motion.div
                  style={{
                    backgroundColor: hovered === industry.id ? "#fff" : "",
                  }}
                  className=" h-150 w-full border  p-3 rounded-4"
                  variants={parentVariants}
                  initial="rest"
                  whileHover="hover"
                  onMouseEnter={() => setHovered(industry.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <motion.div
                    className="d-flex px-4 py-4 flex-column align-items-center align-items-md-start text-center text-md-start"
                    style={
                      {
                        height: "250px"
                      }
                    }
                    variants={childVariants}
                  >
                    <motion.div
                      className="rounded-circle mb-3 d-flex align-items-center justify-content-center"
                      variants={childItemVariants}
                      style={{
                        width: "80px",
                        height: "80px",
                        backgroundColor: hovered === industry.id ? "#fff" : "",
                        transition: "background-color  0.3s",
                      }}
                    >
                      {/* Default icon - slide left and fade out when hovered */}
                      <motion.img
                        src={industry.icon}
                        alt={industry.title}
                        style={{
                          width: 68,
                          height: 68,
                          borderRadius: "50%",
                          position: "relative",
                          zIndex: 1,
                        }}
                        animate={{
                          x: hovered === industry.id ? -12 : 0,
                          opacity: hovered === industry.id ? 0 : 1,
                        }}
                        transition={{ duration: 0.12, ease: "easeOut" }}
                      />

                      {/* On hover, slide the fixed image in from the right */}
                      <motion.img
                        src="https://i.ibb.co.com/6cvgH62h/Icon-14.png"
                        alt={industry.title}
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          position: "absolute",
                          zIndex: 4,
                          pointerEvents: "none",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                        initial={{ x: 10, opacity: 0 }}
                        animate={{
                          x: hovered === industry.id ? 0 : 24,
                          opacity: hovered === industry.id ? 1 : 0,
                        }}
                        exit={{ x: 10, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                      />
                    </motion.div>
                    <motion.h5
                      style={{ fontSize: "2.4rem" }}
                      className="text-black sub-heading   fw-semibold mb-2 "
                      variants={childItemVariants}
                    >
                      {industry.title}
                    </motion.h5>
                    <motion.div variants={childItemVariants}>
                      <p className="text-secondary fqa-text  text-center text-md-start ">
                        {industry.desc}
                      </p>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </div>
            ))}
          </div>
          {/* See more (mobile only) */}
          {isMobile && industries.length > 7 && (
            <div className="text-center mt-3" ref={buttonRef}>
              <button
                className="btn fqa-text text-secondary"
                onClick={() => {
                  if (showAll) {
                    // collapsing
                    setShowAll(false);
                    setTimeout(() => {
                      buttonRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }, 300); // small delay for smooth transition
                  } else {
                    // expanding
                    setShowAll(true);
                  }
                }}
              >
                {showAll ? "See less" : "See more"}
                <span
                  style={{
                    width: "34px",
                    display: "inline-block",
                    transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img style={{ width: "24px" }} src={wrapperIcon} alt="" />
                </span>
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ServicesIndustries;
